/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.IdentityProvider_
///   This is an auto-generated enumeration of the SWFC_Learning.Core.IdentityProvider domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum IdentityProvider_ {
   /// <summary>
   ///   Internal (Azure AD) (swfc)
   /// </summary>
   Internal = 1,
   /// <summary>
   ///   External (Azure AD B2C) (b2c)
   /// </summary>
   External = 2,
   /// <summary>
   ///   Facebook (fb)
   /// </summary>
   Facebook = 3,
   /// <summary>
   ///   Twitter (t)
   /// </summary>
   Twitter = 4,
   /// <summary>
   ///   Amazon (a)
   /// </summary>
   Amazon = 5,
   /// <summary>
   ///   Southwestern Auth Server (swas)
   /// </summary>
   SWAuthServer = 6,
   /// <summary>
   ///   Southwestern Consulting Auth Server (swcas)
   /// </summary>
   SWCAuthServer = 7
}

export const IdentityProviders: IdentityProvider[] = [
   {
      code: IdentityProvider_.Internal,
      literal: 'Internal',
      description: 'Internal (Azure AD)',
      shortDescription: 'swfc',
      listPriority: 0,

      typeName: "IdentityProvider"
   },
   {
      code: IdentityProvider_.External,
      literal: 'External',
      description: 'External (Azure AD B2C)',
      shortDescription: 'b2c',
      listPriority: 0,

      typeName: "IdentityProvider"
   },
   {
      code: IdentityProvider_.Facebook,
      literal: 'Facebook',
      description: 'Facebook',
      shortDescription: 'fb',
      listPriority: 0,

      typeName: "IdentityProvider"
   },
   {
      code: IdentityProvider_.Twitter,
      literal: 'Twitter',
      description: 'Twitter',
      shortDescription: 't',
      listPriority: 0,

      typeName: "IdentityProvider"
   },
   {
      code: IdentityProvider_.Amazon,
      literal: 'Amazon',
      description: 'Amazon',
      shortDescription: 'a',
      listPriority: 0,

      typeName: "IdentityProvider"
   },
   {
      code: IdentityProvider_.SWAuthServer,
      literal: 'SWAuthServer',
      description: 'Southwestern Auth Server',
      shortDescription: 'swas',
      listPriority: 0,

      typeName: "IdentityProvider"
   },
   {
      code: IdentityProvider_.SWCAuthServer,
      literal: 'SWCAuthServer',
      description: 'Southwestern Consulting Auth Server',
      shortDescription: 'swcas',
      listPriority: 0,

      typeName: "IdentityProvider"
   }
]

export class IdentityProvider implements IDomainModel {
   code: IdentityProvider_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: IdentityProvider_): IdentityProvider {
      return IdentityProviders.find(d => d.code === code)
   }
}
